export const TopStudents1400 = [
    {
        id: 1,
        fullName: "محمدمهدی‌ امیرحسینی",
        videoLink: "https://www.aparat.com/v/ySE57",
        profileImage: "hoseini-profile.webp",
        backgroundImage: "hoseini.webp",
        professor: '',
        multiProfessor: false,
        rank: '۹۴',
    },
    {

        id: 2,
        fullName: "علی سعیدی",
        videoLink: "https://www.aparat.com/v/Ijyrp",
        profileImage: "saeidi-profile.webp",
        backgroundImage: "saeidi.webp",
        multiProfessor: false,
        professor: 'حیدری',
        rank: '۸۴',
    },
    {
        id: 3,
        fullName: "محمدرضا شایان‌راد",
        videoLink: "https://www.aparat.com/v/Q4FUC",
        profileImage: "raad-profile.webp",
        backgroundImage: "raad.webp",
        multiProfessor: false,
        professor: 'حیدری',
        rank: '۸۱',
    },

    {
        id: 4,
        fullName: "حسین حسن‌زاده",
        videoLink: "https://www.aparat.com/v/Zdw9Y",
        profileImage: "hasanzade-profile.webp",
        backgroundImage: "hasanzade.webp",
        multiProfessor: false,
        professor: 'حیدری',
        rank: '۷۲',
    },
    {
        id: 5,
        fullName: "فاطمه مختاری",
        videoLink: "https://www.aparat.com/v/wlrGe",
        profileImage: "mokhtari-profile.webp",
        backgroundImage: "vaezi-top-students.webp",
        multiProfessor: false,
        professor: 'واعظی',
        rank: '۵۷',
    },
    {
        id: 6,
        fullName: "فاطمه مختاری",
        videoLink: "https://www.aparat.com/v/vrdWA",
        profileImage: "mokhtari-profile.webp",
        backgroundImage: "mokhtari-sadat2.webp",
        multiProfessor: false,
        professor: 'سادات',
        rank: '۵۷',
    },
    {
        id: 7,
        fullName: "فاطمه مختاری",
        videoLink: "https://www.aparat.com/v/Kh9i4",
        profileImage: "mokhtari-profile.webp",
        backgroundImage: "mokhtari-mosalai.webp",
        multiProfessor: false,
        professor: 'مصلایی',
        rank: '۵۷',
    },
    {
        id: 8,
        fullName: "فاطمه مختاری",
        videoLink: "https://www.aparat.com/v/lLrXh",
        profileImage: "mokhtari-profile.webp",
        backgroundImage: "mokhtari-nokande.webp",
        multiProfessor: false,
        professor: 'نوکنده',
        rank: '۵۷',
    },
    {
        id: 9,
        fullName: "ریحانه حاجبی",
        videoLink: "https://www.aparat.com/v/pSJmc",
        profileImage: "hajabi-profile.webp",
        backgroundImage: "hajabi-heydari.webp",
        multiProfessor: false,
        professor: 'حیدری',
        rank: '۴۲',
    },
    {
        id: 10,
        fullName: "علیرضا کامکار",
        videoLink: "https://www.aparat.com/v/3feE8",
        profileImage: "kamkar-profile.webp",
        backgroundImage: "kamkar.webp",
        multiProfessor: false,
        professor: 'حیدری',
        rank: '۴۰',
    },
    {
        id: 11,
        fullName: "فاطمه سلیمانی",
        videoLink: "https://www.aparat.com/v/QIsHm",
        profileImage: "soleymani-profile.webp",
        backgroundImage: "soleymani-sadat.webp",
        multiProfessor: false,
        professor: 'سادات',
        rank: '۲۴',
    },
    {
        id: 12,
        fullName: "فاطمه سلیمانی",
        videoLink: "https://www.aparat.com/v/j2hQA",
        profileImage: "soleymani-profile.webp",
        backgroundImage: "soleymani-nokande.webp",
        multiProfessor: false,
        professor: 'نوکنده',
        rank: '۲۴',
    },
    {
        id: 13,
        fullName: "فاطمه سلیمانی",
        videoLink: "https://www.aparat.com/v/7GEmM",
        profileImage: "soleymani-profile.webp",
        backgroundImage: "soleymani-mosalai.webp",
        multiProfessor: false,
        professor: 'مصلایی',
        rank: '۲۴',
    },
    {
        id: 14,
        fullName: "فاطمه سلیمانی",
        videoLink: "https://www.aparat.com/v/1Kq7Y",
        profileImage: "soleymani-profile.webp",
        backgroundImage: "soleymani-yekta.webp",
        multiProfessor: false,
        professor: 'یکتا',
        rank: '۲۴',
    },
    {
        id: 15,
        fullName: "فاطمه سلیمانی",
        videoLink: "https://www.aparat.com/v/wlrGe",
        profileImage: "soleymani-profile.webp",
        backgroundImage: "vaezi-top-students.webp",
        multiProfessor: false,
        professor: 'واعظی',
        rank: '۲۴',
    },
    {
        id: 16,
        fullName: "محمد حسن فلاحت",
        videoLink: "https://www.aparat.com/v/WTEz0",
        profileImage: "falahat-profile.webp",
        backgroundImage: "felahat-moradi.webp",
        multiProfessor: false,
        professor: 'مرادی',
        rank: '۸',
    },
];
export const TopStudents1401 = [
    {
        id: 1,
        fullName: "آیسا فخاری",
        videoLink: "https://www.aparat.com/v/y8MWQ",
        profileImage: "fakhari-profile.webp",
        backgroundImage: "fakhari-vaezi.webp",
        professor: 'واعظی',
        multiProfessor: false,
        rank: '۸۰',
    },
    {
        id: 2,
        fullName: "فردین برهور",
        videoLink: "https://www.aparat.com/v/eD745",
        profileImage: "barhoor-profile.webp",
        backgroundImage: "barhoor-kiasalar.webp",
        professor: 'کیاسالار',
        multiProfessor: false,
        rank: '۵۴',
    },
    {
        id: 3,
        fullName: "فردین برهور",
        videoLink: "https://www.aparat.com/v/Mgp5Q",
        profileImage: "barhoor-profile.webp",
        backgroundImage: "barhoor-yekta.webp",
        professor: 'یکتا',
        multiProfessor: false,
        rank: '۵۴',
    },
    {
        id: 4,
        fullName: "رضا صادقی",
        videoLink: "https://www.aparat.com/v/mwnZY",
        profileImage: "sadeghi-profile.webp",
        backgroundImage: "sadeghi-amarlou.webp",
        professor: 'عمارلو',
        multiProfessor: false,
        rank: '۱۵',
    },
    {
        id: 5,
        fullName: "سید امیرحسین حسینی",
        videoLink: "https://www.aparat.com/v/UJ1G3",
        profileImage: "seyed-hoseini-profile.webp",
        backgroundImage: "seyed-hoseini.webp",
        professor: '',
        multiProfessor: true,
        rank: '۸',
    },


    {
        id: 6,
        fullName: "علی اصغر وجدانی",
        videoLink: "https://www.aparat.com/v/Hqjxi",
        profileImage: "vejdani-profile.webp",
        backgroundImage: "vejdani.webp",
        professor: '',
        multiProfessor: true,
        rank: '۶',
    },
    {
        id: 7,
        fullName: "محمد بهرامی",
        videoLink: "https://www.aparat.com/v/RQFd8",
        profileImage: "bahrami-profile.webp",
        backgroundImage: "bahrami-fathi.webp",
        professor: 'فتحی',
        multiProfessor: false,
        rank: '۱',
    },
    {
        id: 8,
        fullName: "محمد بهرامی",
        videoLink: "https://www.aparat.com/v/9dH0y",
        profileImage: "bahrami-profile.webp",
        backgroundImage: "bahrami-foroughi.webp",
        professor: 'فروغی‌نیا',
        multiProfessor: false,
        rank: '۱',
    },

    {
        id: 9,
        fullName: "کیاناز شاطریان",
        videoLink: "https://www.aparat.com/v/9r1Zd",
        profileImage: "shaterian-profile.webp",
        backgroundImage: "shaterian.webp",
        professor: '',
        multiProfessor: true,
        rank: '۱',
    },

];

export const TopStudents1402 = [
    [
        {
            id: 1,
            fullName: "کیمیا قدیر",
            backgroundImage: "3.svg",
            measure:'رشته ریاضی',
            rank: '۳',
            isGold:true
        },
        {
            id: 2,
            fullName: "محمدامین سالاری‌فر",
            backgroundImage: "3.svg",
            measure:'رشته تجربی',
            rank: '۳',
            isGold:true

        },
        {
            id: 3,
            fullName: "ماهان معصوم زاده",
            backgroundImage: "7.svg",
            measure:'رشته ریاضی',
            rank: '۷',
            isGold:true

        },
        {
            id: 4,
            fullName: "امیرمهدی طماسبی",
            backgroundImage: "8.svg",
            measure:'رشته تجربی',
            rank: '۸',
            isGold:true

        },
        {
            id: 5,
            fullName: "امیرمحمد حمیدی",
            backgroundImage: "9.svg",
            measure:'رشته ریاضی',
            rank: '۹',
            isGold:true

        },
    ],
    [
        {
            id: 6,
            fullName: "امیرحسین آقایاری",
            backgroundImage: "12.svg",
            measure:'رشته تجربی',
            rank: '۱۲',
            isGold:false
        },
        {
            id: 7,
            fullName: "پوریا منصوری ",
            backgroundImage: "17.svg",
            measure:'رشته انسانی',
            rank: '۱۷',
            isGold:false

        },
        {
            id: 8,
            fullName: "مهدیه مددی",
            backgroundImage: "20.svg",
            measure:'رشته هنر',
            rank: '۲۰',
            isGold:false

        },
        {
            id: 9,
            fullName: "مهدی شکری ",
            backgroundImage: "32.svg",
            measure:'رشته تجربی',
            rank: '۳۲',
            isGold:false

        },
        {
            id: 10,
            fullName: "امیرحسین میرزایی",
            backgroundImage: "33.svg",
            measure:'رشته ریاضی',
            rank: '۳۳',
            isGold:false

        },
    ],
    [
        {
            id: 11,
            fullName: "درسا گلچوب ",
            backgroundImage: "36.svg",
            measure:'رشته تجربی',
            rank: '۳۶',
            isGold:false

        },
        {
            id: 12,
            fullName: "محمد حسین حمیدی  ",
            backgroundImage: "37.svg",
            measure:'رشته انسانی',
            rank: '۳۷',
            isGold:false

        },
        {
            id: 13,
            fullName: "علی رجبعلی پور",
            backgroundImage: "41.svg",
            measure:'رشته تجربی',
            rank: '۴۱',
            isGold:false

        },
        {
            id: 14,
            fullName: "روژین روحانی ",
            backgroundImage: "43.svg",
            measure:'رشته ریاضی',
            rank: '۴۳',
            isGold:false

        },
        {
            id: 15,
            fullName: "آروین صالحی",
            backgroundImage: "45.svg",
            measure:'رشته تجربی',
            rank: '۴۵',
            isGold:false

        },
    ],

    [
        {
            id: 16,
            fullName: "حسین ناجی ",
            backgroundImage: "57.svg",
            measure:'رشته هنر',
            rank: '۵۷',
            isGold:false

        },
        {
            id: 17,
            fullName: "محمد جلیل رستم پور ملالی ",
            backgroundImage: "59.svg",
            measure:'رشته ریاضی',
            rank: '۵۹',
            isGold:false

        },
        {
            id: 18,
            fullName: "محدثه فاضلی ",
            backgroundImage: "60.svg",
            measure:'رشته هنر',
            rank: '۶۰',
            isGold:false

        },
        {
            id: 19,
            fullName: "محمدرضا اسماعیل پور",
            backgroundImage: "63.svg",
            measure:'رشته تجربی',
            rank: '۶۳',
            isGold:false

        },
        {
            id: 20,
            fullName: "مهدی باقریان",
            backgroundImage: "63.svg",
            measure:'رشته تجربی',
            rank: '۶۳',
            isGold:false

        },
    ],
    [
        {
            id: 21,
            fullName: "مسیح شیخی",
            backgroundImage: "65.svg",
            measure:'رشته ریاضی',
            rank: '۶۵',
            isGold:false

        },
        {
            id: 22,
            fullName: "محمد عرفان اسدی",
            backgroundImage: "69.svg",
            measure:'رشته انسانی',
            rank: '۶۹',
            isGold:false

        },
        {
            id: 23,
            fullName: "نگار خزاعی",
            backgroundImage: "71.svg",
            measure:'رشته انسانی',
            rank: '۷۱',
            isGold:false

        },

        {
            id: 24,
            fullName: "امیر عطاپوری",
            backgroundImage: "77.svg",
            measure:'رشته تجربی',
            rank: '۷۷',
            isGold:false
        },
        {
            id: 25,
            fullName: "متین شیرازی",
            backgroundImage: "77.svg",
            measure:'رشته تجربی',
            rank: '۷۷',
            isGold:false

        },
    ],
    [
        {
            id: 26,
            fullName: "مبینا پیری",
            backgroundImage: "81.svg",
            measure:'رشته انسانی',
            rank: '۸۱',
            isGold:false

        },
        {
            id: 27,
            fullName: "محمدهادی محمودی ",
            backgroundImage: "81.svg",
            measure:'رشته انسانی',
            rank: '۸۱',
            isGold:false

        },
        {
            id: 28,
            fullName: "نجمه دوستعلی ",
            backgroundImage: "82.svg",
            measure:'رشته هنر',
            rank: '۸۲',
            isGold:false

        },
        {
            id: 29,
            fullName: "امیررضا عباس زاده ",
            backgroundImage: "87.svg",
            measure:'رشته ریاضی',
            rank: '۸۷',
            isGold:false

        },
        {
            id: 30,
            fullName: "طوبی محمودیان",
            backgroundImage: "91.svg",
            measure:'رشته هنر',
            rank: '۹۱',
            isGold:false
        },
    ]
]
